export default __webpack_public_path__ + "static/The Backdrop_image 1@2x-636bccf104eb1e62df3e07af0c821168.jpg";